import { compile } from "path-to-regexp";

export const policy = compile("policies/:id");
export const policyPdf = compile("policies/:id/pdf");
